'use client';

import { forwardRef, type HTMLAttributes } from 'react';

import { cn } from '../../../../lib/utils';
import StepperItem from './StepperItem';

export interface StepperProps extends HTMLAttributes<HTMLDivElement> {
  /** 증가 버튼 클릭 핸들러 */
  onIncrement?: () => void;
  /** 감소 버튼 클릭 핸들러 */
  onDecrement?: () => void;
  /** 증가 버튼 비활성화 */
  disableIncrement?: boolean;
  /** 감소 버튼 비활성화 */
  disableDecrement?: boolean;
  /** 전체 비활성화 */
  disabled?: boolean;
}

/**
 * Stepper - 숫자 증가/감소 컨트롤 컴포넌트
 *
 * StepperItem(up) + StepperItem(down)이 세로로 배치된 구조입니다.
 * 숫자 입력 필드와 함께 사용하여 값을 조절합니다.
 */
const Stepper = forwardRef<HTMLDivElement, StepperProps>(
  (
    {
      className,
      onIncrement,
      onDecrement,
      disableIncrement,
      disableDecrement,
      disabled,
      ...props
    },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        className={cn(
          'flex flex-col items-center justify-center gap-[4px]',
          className,
        )}
        {...props}
      >
        <StepperItem
          direction="up"
          onClick={onIncrement}
          disabled={disabled || disableIncrement}
        />
        <StepperItem
          direction="down"
          onClick={onDecrement}
          disabled={disabled || disableDecrement}
        />
      </div>
    );
  },
);

Stepper.displayName = 'Stepper';

export default Stepper;
